import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from 'toolkit/components/ToolkitPageLayout'
import { institution_relationship_placeholder } from 'assets'

const pageLinks = [
  {
    title: 'Establishing a Sickle Cell Disease Clinic',
    path: '/toolkit/institution/establishing-scd-clinic',
    image: institution_relationship_placeholder,
    altText: 'Image for Establishing a Sickle Cell Disease Clinic',
    description: 'Learn the foundational steps for setting up an SCD clinic.'
  },
  {
    title: 'Business Plan & Checklist',
    path: '/toolkit/institution/business-plan-checklist',
    image: institution_relationship_placeholder,
    altText: 'Image for Business Plan & Checklist',
    description:
      'Tools and templates for developing a comprehensive business plan.'
  },
  {
    title: 'IC Equipment Checklist',
    externalUrl:
      'https://docs.google.com/presentation/d/e/2PACX-1vSEPaxIv9C4DmZEI7or8ah3nBs5mVWGDhCqXOFWS6EPBBymJA00gtyBwsXAjDq3UA/pub?start=false&loop=false&delayms=3000',
    image: institution_relationship_placeholder,
    altText: 'Image for IC Equipment Checklist',
    description:
      'A checklist for essential infusion clinic equipment (opens new tab).',
    isExternal: true
  }
]

export const InstitutionBuildingIcResourcesPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' },
    {
      label: 'Resources for Building an IC',
      path: '/toolkit/institution/building-ic-resources'
    }
  ]

  return (
    <ToolkitPageLayout
      title="Resources for Building a Sickle Cell Infusion Clinic (IC)"
      breadcrumbs={breadcrumbs}
    >
      <div className="container mx-auto px-4 py-8">
        <p className="text-lg text-gray-700 mb-8 text-center">
          Click on a module below to review tools and resources for establishing
          and equipping your Sickle Cell Infusion Clinic.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {pageLinks.map((link) => {
            if (link.isExternal) {
              return (
                <a
                  key={link.title}
                  href={link.externalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out border border-gray-200"
                >
                  <img
                    src={link.image}
                    alt={link.altText}
                    className="w-full h-48 object-cover rounded-md mb-4"
                  />
                  <h3 className="text-xl font-semibold text-[#142841] mb-2">
                    {link.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-2">
                    {link.description}
                  </p>
                  <p className="text-sm text-[#3C2416] group-hover:text-[#A6410A]">
                    View External Resource
                  </p>
                </a>
              )
            }
            return (
              <Link
                key={link.title}
                to={link.path!}
                className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out border border-gray-200"
              >
                <img
                  src={link.image}
                  alt={link.altText}
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <h3 className="text-xl font-semibold text-[#142841] mb-2">
                  {link.title}
                </h3>
                <p className="text-sm text-gray-600 mb-2">{link.description}</p>
                <p className="text-sm text-[#3C2416] group-hover:text-[#A6410A]">
                  Learn more
                </p>
              </Link>
            )
          })}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/toolkit/institution"
            className="inline-block bg-[#A6410A] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#C25F0C] transition-colors duration-300"
          >
            All done? Click here to return to the Institution screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
